import { FC, useState } from 'react';
import { Icon } from '@iconify/react';
import { motion } from 'framer-motion';
import { SearchApi } from '@api/technologies/search';
import { Divider, Stack, Typography } from '@mui/material';
import { useGlobalDrawerContext } from '../GlobalDrawer';
import { TechExtendedRiskIndicator } from './ExtendedRiskIndicator';
import { Loading } from '../Loading';

interface TechRiskIndicatorProps {
  tech: string;
}

export const TechRiskIndicator: FC<TechRiskIndicatorProps> = ({ tech }) => {
  const { showDrawer } = useGlobalDrawerContext();

  const [painted, setPainted] = useState<boolean>(false);

  return (
    <>
      <motion.div
        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
        transition={{ delay: 0.25 }}
        whileHover={{ scale: 1.1 }}
        onClick={(event) => {
          event.stopPropagation();

          showDrawer(
            `loading-tech-risk`,
            (lastId: string, closed: boolean) => {
              if (closed && lastId === `loading-tech-risk`) {
                setPainted(false);
              } else if (lastId !== `loading-tech-risk`) {
                setPainted(false);
              } else {
                setPainted(true);
              }
            },
            <Stack
              spacing={3}
              justifyContent={'center'}
              alignItems={'center'}
              sx={{ px: 2, maxWidth: 400 }}
            >
              <Stack direction={'row'} spacing={1} alignItems={'center'}>
                <Icon icon={'bx:chip'} fontSize={30} />
                <Typography variant={'h6'}>Related Technology Risks</Typography>
              </Stack>
              <Divider variant={'middle'} sx={{ width: '100%' }} />
              <Loading />
            </Stack>,
          );
          SearchApi.generalSearch(
            [
              {
                q: tech.toLowerCase(),
                field: 'keywords',
                operator: 'OR',
                accuracy: 'Vague',
              },
            ],
            {},
          ).then((res) => {
            showDrawer(
              `${tech}-tech-risk`,
              (lastId: string, closed: boolean) => {
                if (closed && `${tech}-tech-risk` === lastId) {
                  setPainted(false);
                } else if (`${tech}-tech-risk` !== lastId) {
                  setPainted(false);
                } else {
                  setPainted(true);
                }
              },
              <TechExtendedRiskIndicator
                keywordRisks={res.data.filter(
                  (value, index, self) =>
                    index ===
                    self.findIndex(
                      (t) =>
                        t.keyword.toLowerCase() === value.keyword.toLowerCase(),
                    ),
                )}
              />,
            );
          });
        }}
      >
        <Icon
          icon={'bx:chip'}
          fontSize={40}
          color={painted ? 'grey' : 'white'}
        />
      </motion.div>
    </>
  );
};
